<template>
    <div
        class="a-switch-circle switch-circle"
        :class="{'switch-circle--active': localValue }"
    >
        <span class="switch-circle__label" v-html="label" />
        <button
            type="button"
            role="button"
            class="switch-circle__button"
            :aria-label="ariaLabel"
            @click="handleClick"
            tabindex="-1"
        >
            <svg-icon
                original
                name="icons/switcher-circle-icon"
                class="switch-circle__button-icon"
            />
        </button>
    </div>
</template>

<script>
export default {
    name: 'ASwitchCircle',
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: 'Switch circle button'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    methods: {
        handleClick() {
            this.$emit('onClose', true);
            this.localValue = !this.localValue;
        }
    }
}
</script>

<style lang="scss">
@import "a-switch-circle.scss";   
</style>